import { render, staticRenderFns } from "./AddDrawer.vue?vue&type=template&id=8ed48a8c&scoped=true"
import script from "./AddDrawer.vue?vue&type=script&lang=js"
export * from "./AddDrawer.vue?vue&type=script&lang=js"
import style0 from "./AddDrawer.vue?vue&type=style&index=0&id=8ed48a8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed48a8c",
  null
  
)

export default component.exports